import { useEffect, useState } from "react";
import ResponsiveTable from "../table"
import { FaArrowRight } from "react-icons/fa6";
import Accordion from "../campusLife/accordion";
import { PropTypes } from 'prop-types';
import { DecodeHtml } from "../../utils/decodeHtml";
import { MyTable } from "../campusLife/swimmingPoolHours";
import { retrunAssets } from "../../utils/getAssets";

const StudentGuideLine = ({ internationalOffice }) => {


    const gEMGuidelineTitle = internationalOffice?.gEMGuidelineTitle
    const subHead = internationalOffice?.subHead


    const [tableData, setTableData] = useState({
        headers: [],
        mobile: [],
        contents: []
    });

    useEffect(() => {
        const headers = [];
        const mobile = [];
        const contents = [];

        internationalOffice?.gEMTable?.items.forEach((item) => {
            // Extract the label for the header
            const headerLabel = item?.content?.properties?.label;
            headers.push(headerLabel);
            mobile.push(headerLabel);

            const rowData = [];
            item?.content?.properties?.content?.items?.forEach((contentItem) => {
                // Extract the content for each cell
                const cellContent = contentItem?.content?.properties?.richText?.markup;
                rowData.push(DecodeHtml({ html: cellContent }));
            });
            contents.push(rowData);
        });

        setTableData({ headers, mobile, contents });
    }, [internationalOffice?.gEMTable]);
    const [accordion, setAccordion] = useState([]);

    useEffect(() => {
        setAccordion([
            {
                question: internationalOffice?.gEMPOLICY,
                answer:
                    <div className="grid grid-cols-1 md:grid-cols-[70%_30%] gap-10 items-center">
                        <p className="w-auto whitespace-pre-line text-justify text-sky-950 text- text-base font-normal leading-normal">{
                            DecodeHtml({ html: internationalOffice?.pOLICYDESCRIPTION?.markup })
                        }</p>
                        <a href={internationalOffice?.gEMPOLICYDownloadButton?.items[0]?.content?.properties?.link} target="_blank" rel="noreferrer" className="px-8 py-4 bg-red-800 rounded justify-center items-center gap-4 w-fit flex">
                            <span className="text-white text-base font-bold  flex items-center gap-3">{internationalOffice?.gEMPOLICYDownloadButton?.items[0]?.content?.properties?.label} <FaArrowRight /></span>
                        </a>
                    </div>
                ,
                open: true
            },
            {
                question: internationalOffice?.gEMPROCESS,
                answer:
                    <div className="grid grid-cols-1 md:grid-cols-[70%_30%] gap-10 items-center">
                        <p className="w-auto  text-justify text-sky-950 text- text-base font-normal leading-normal">{
                            DecodeHtml({ html: internationalOffice?.processDescription?.markup })
                        }</p>
                        <a href={internationalOffice?.processDownloadButton?.items[0]?.content?.properties?.link} target="_blank" rel="noreferrer" className="px-8 py-4 bg-red-800 rounded justify-center items-center gap-4 w-fit flex">
                            <span className="text-white text-base font-bold capitalize flex items-center gap-3">{internationalOffice?.processDownloadButton?.items[0]?.content?.properties?.label} <FaArrowRight /></span>
                        </a>
                    </div>
                ,
                open: false
            },
            {
                question: internationalOffice?.applicationDates,
                answer:
                    <div className="grid grid-cols-1 md:grid-cols-[70%_30%] gap-10 items-center">
                        <p className="w-auto  text-justify text-sky-950 text- text-base font-normal leading-normal">{
                            DecodeHtml({ html: internationalOffice?.applicationDatesDescription?.markup })
                        }</p>

                    </div>
                ,
                open: false
            },
            {
                question: internationalOffice?.collegeReviewForm,
                answer:
                    <div className="grid grid-cols-1 md:grid-cols-[70%_30%] gap-10 items-center">
                        <p className="w-auto  text-justify text-sky-950  text-base font-normal leading-normal">{
                            DecodeHtml({ html: internationalOffice?.collegeReviewFormDescription?.markup })
                        }</p>

                    </div>
                ,
                open: false
            },
            {
                question: internationalOffice?.note,
                answer:
                    <div className="grid grid-cols-1 md:grid-cols-[70%_30%] gap-10 items-center">
                        <p className="w-auto  text-justify text-sky-950 text- text-base font-normal leading-normal">{
                            DecodeHtml({ html: internationalOffice?.noteDescription?.markup })
                        }</p>

                    </div>
                ,
                open: false
            },
        ])
    }, [internationalOffice])



    return (
        <div className="flex flex-col w-full items-center gap-5 mt-10">
            <h1 className="w-auto text-2xl font-bold text-slate-900  2xl:text-5xl leading-tight">{gEMGuidelineTitle}</h1>
            <div className="w-full flex flex-col gap-5">
                <h2 className="w-auto  font-bold text-[#071946B2] text-xl leading-tight">{subHead}</h2>
                <div className="overflow-x-auto">
                    <MyTable headers={tableData.headers} mobile={tableData.mobile} contents={tableData.contents} />
                </div>

                <div className="w-full my-8">
                    <Accordion accordion={accordion} setAccordion={setAccordion} />
                </div>
            </div>
        </div>
    )
}
StudentGuideLine.propTypes = {
    internationalOffice: PropTypes.object
}
export default StudentGuideLine